import React, { useRef, useState } from "react";
import "../assets/print/PrintStatement.css";
import html2pdf from "html2pdf.js";

const PrintStatement = () => {
  const [formData, setFormData] = useState({
    accountNumber: "",
    fromDate: "",
    toDate: "",
  });

  const [customer, setCustomer] = useState(null);
  const [transactions, setTransactions] = useState([]);

  const detailsRef = useRef(null);

  // Mock API – replace with real API call
  const fetchStatementData = () => {
    return {
      customer: {
        name: "Abhishek Kumar",
        account: formData.accountNumber,
        bank: "Central Bank of India",
      },
      transactions: [
        {
          date: formData.fromDate,
          narration: "Opening Balance",
          type: "CR",
          amount: 5000,
          balance: 5000,
        },
        {
          date: "2025-12-03",
          narration: "ATM Withdrawal",
          type: "DR",
          amount: 1500,
          balance: 3500,
        },
        {
          date: formData.toDate,
          narration: "Salary Credit",
          type: "CR",
          amount: 30000,
          balance: 33500,
        },
        {
          date: formData.toDate,
          narration: "Salary Credit",
          type: "CR",
          amount: 30000,
          balance: 33500,
        },
        {
          date: formData.toDate,
          narration: "Salary Credit",
          type: "CR",
          amount: 30000,
          balance: 33500,
        },
        {
          date: formData.toDate,
          narration: "Salary Credit",
          type: "CR",
          amount: 30000,
          balance: 33500,
        },
        {
          date: formData.toDate,
          narration: "Salary Credit",
          type: "CR",
          amount: 30000,
          balance: 33500,
        },
        {
          date: formData.toDate,
          narration: "Salary Credit",
          type: "CR",
          amount: 30000,
          balance: 33500,
        },
        {
          date: formData.toDate,
          narration: "Salary Credit",
          type: "CR",
          amount: 30000,
          balance: 33500,
        },
      ],
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = fetchStatementData();
    setCustomer(data.customer);
    setTransactions(data.transactions);
  };

  const handleDownloadPDF = () => {
    const element = detailsRef.current;

    const opt = {
      margin: [5, 5, 5, 5],
      filename: "Account_statement.pdf",
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        scale: 3,
        useCORS: true,
        allowTaint: true,
        logging: false,
      },
      jsPDF: {
        unit: "mm",
        format: "a4",
        orientation: "portrait",
      },
    };

    html2pdf().set(opt).from(element).save();
  };

  return (
    <div className="print-statement-wrapper">
      <div className="print-statement-container">
        <form className="account-statement-form" onSubmit={handleSubmit}>
          <h2>Account Statement Form</h2>

          <div className="account-statement-inputs">
            <div className="account-statement-input-group">
              <label>Account Number</label>
              <br />
              <input
                type="text"
                placeholder="Enter account number"
                value={formData.accountNumber}
                onChange={(e) =>
                  setFormData({ ...formData, accountNumber: e.target.value })
                }
                required
              />
            </div>

            <div className="account-statement-input-group">
              <label>From Date</label>
              <br />
              <input
                type="date"
                value={formData.fromDate}
                onChange={(e) =>
                  setFormData({ ...formData, fromDate: e.target.value })
                }
                required
              />
            </div>

            <div className="account-statement-input-group">
              <label>To Date</label>
              <br />
              <input
                type="date"
                value={formData.toDate}
                onChange={(e) =>
                  setFormData({ ...formData, toDate: e.target.value })
                }
                required
              />
            </div>
          </div>

          <button type="submit">Submit</button>
        </form>
      </div>

      {customer && (
        <div className="statement-details-wrapper">
          <section ref={detailsRef} className="statement-details-section">
            <h2>Account Statement Details</h2>

            {/* Customer Header */}
            <div className="customer-details">
              <div>
                <div>
                  <b>Customer Name:</b> {customer.name}
                </div>
                <div>
                  <b>Account Number:</b> {customer.account}
                </div>
                <div>
                  <b>{customer.bank}</b>
                </div>
              </div>

              <div className="statement-period">
                <div>
                  <b>Statement Period</b>
                </div>
                <div>
                  {new Date(formData.fromDate).toLocaleDateString("en-GB")} to  {new Date(formData.toDate).toLocaleDateString("en-GB")}
                </div>
              </div>
            </div>

            {/* Table */}
            <div className="table-wrapper">
              <table className="statement-details-table">
                <thead>
                  <tr>
                    <th>Date</th>
                    <th>Narration</th>
                    <th>Dr/Cr</th>
                    <th>Amount</th>
                    <th>Balance</th>
                  </tr>
                </thead>

                <tbody>
                  {transactions.map((t, index) => (
                    <tr key={index}>
                      <td>{t.date}</td>
                      <td>{t.narration}</td>
                      <td>{t.type}</td>
                      <td>{t.amount}</td>
                      <td>{t.balance}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </section>

          <div>
            <button className="download-btn" onClick={handleDownloadPDF}>
              Download
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default PrintStatement;
